import './LoadingSpinner.css';

// Shared in-content loading indicator — replaces the ~5 duplicated hand-rolled spinner divs
// that used to live one per page (LineupReport, CloudInGameTrack, PitcherVideo, Login,
// ProtectedRoute) plus the plain "Loading..." text pages fell back to otherwise. Drop this in
// wherever a section is waiting on a fetch; pair with <ErrorState> for the failure case so
// "still loading" and "broken" never look the same (blank/stale) to the user.
function LoadingSpinner({ size = 'md', label }) {
  return (
    <div className={`ls-wrap ls-${size}`} role="status" aria-live="polite">
      <div className="ls-circle" />
      {label && <div className="ls-label">{label}</div>}
    </div>
  );
}

export default LoadingSpinner;
